import { useForm } from "react-hook-form";
import { useState } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faHouse } from "@fortawesome/free-solid-svg-icons";
import { Link } from "react-router-dom";

function ForgotPassword() {
  const { register, handleSubmit, formState: { errors } } = useForm();
  const [status, setStatus] = useState(null); // null | "success" | "error"
  const [loading, setLoading] = useState(false);
  const [message, setMessage] = useState("");

  const onSubmit = async (data) => {
    setLoading(true);
    setStatus(null);
    try {
      const response = await fetch("/api/forgot-password", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ email: data.email }),
      });
      const result = await response.json();
      if (response.ok) {
        setStatus("success");
        setMessage(result.message || "If that email exists, a reset link has been sent.");
      } else {
        setStatus("error");
        setMessage(result.message || "Something went wrong. Please try again.");
      }
    } catch {
      setStatus("error");
      setMessage("Error connecting to server. Please try again.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="container d-flex justify-content-center align-items-center" style={{ minHeight: "70vh" }}>
      <div className="col-12 col-sm-8 col-md-6 col-lg-5 p-4 border rounded shadow-sm bg-white">
        <div className="text-center mb-3">
          <FontAwesomeIcon icon={faHouse} size="2x" className="text-primary mb-2" />
          <h4 className="mb-0">Forgot your password?</h4>
          <p className="text-muted small mt-1">
            Enter your registered email and we'll send you a reset link.
          </p>
        </div>

        {status === "success" ? (
          <div className="alert alert-success" role="alert">
            {message}
            <div className="mt-2">
              <Link to="/login" className="btn btn-sm btn-outline-primary">Back to Login</Link>
            </div>
          </div>
        ) : (
          <form onSubmit={handleSubmit(onSubmit)} noValidate>
            {status === "error" && (
              <div className="alert alert-danger py-2 small">{message}</div>
            )}
            <div className="form-group mb-3">
              <label htmlFor="reset-email">Email address <span className="text-danger">*</span></label>
              <input
                id="reset-email"
                type="email"
                className="form-control mt-1"
                placeholder="you@example.com"
                {...register("email", {
                  required: "Email is required.",
                  pattern: {
                    value: /^[a-zA-Z0-9_.+-]+@[a-zA-Z0-9-]+\.[a-zA-Z0-9-.]+$/i,
                    message: "Enter a valid email address.",
                  },
                })}
              />
              {errors.email && (
                <span className="text-danger small">{errors.email.message}</span>
              )}
            </div>

            <div className="d-grid mb-3">
              <button type="submit" className="btn btn-primary" disabled={loading}>
                {loading ? "Sending…" : "Send Reset Link"}
              </button>
            </div>

            <div className="text-center small">
              <Link to="/login" className="text-decoration-none">Back to Login</Link>
            </div>
          </form>
        )}
      </div>
    </div>
  );
}

export default ForgotPassword;
